import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import ExaminationRowT1 from './ExaminationRowT1'
import ExaminationRowT2 from './ExaminationRowT2'
import ExaminationRowT3 from './ExaminationRowT3'
import ExaminationRowT4 from './ExaminationRowT4'
import { TableBody, Table, TableCell, TableHead, TableRow } from '@mui/material'

const SummaryRow = ({ skip, examinations }) => {
  const [sum, setSum] = useState(0)

  useEffect(() => {
    calculateSum(examinations)
  }, [examinations])

  const calculateSum = (examinations) => {
    let temp = 0

    let keys = Object.keys(examinations)
    for (let i = 0; i < keys.length; i++) {
      let row = examinations[keys[i]]

      temp += row.price_gross ? Number(row.price_gross) : 0
    }
    setSum(temp)
  }

  return (
    <TableRow>
      {[...Array(skip)].map((value, index) => (
        <TableCell id={index + 1} key={index} />
      ))}
      <TableCell align="right">Suma brutto</TableCell>
      <TableCell>
        {Number(sum).toFixed(2).toString().replace('.', ',')} zł
      </TableCell>
      <TableCell></TableCell>
    </TableRow>
  )
}

SummaryRow.propTypes = {
  skip: PropTypes.number,
  examinations: PropTypes.object,
}

const ExaminationsTable = ({
  type,
  formik,
  handleChange,
  assignFileToComponent,
  deleteRow,
  editFile,
  summarySkip,
  examinations,
  finalize,
  edit,
  internal = false,
  patient = null,
  getFiles,
}) => {
  // const [fields, setFields] = useState([])
  // const [faceSizes, setFaceSizes] = useState([])
  const [headers, setHeaders] = useState([])
  // const [usedFiles, setUsedFiles] = useState({
  //   2: [],
  //   3: [],
  // })
  useEffect(() => {
    chooseHeaders(type)
    // loadFacesSizes()
    // loadFields()
  }, [type])

  const chooseHeaders = (type) => {
    let dHeaders = ['Badanie', 'Nr. zęba', 'DAP', 'Cena']
    let aHeaders = ['Badanie', 'Nr. zęba', 'Moc', 'Natężenie', 'Czas', 'Cena']
    if (finalize || (edit && formik.values.status_id != 1)) {
      dHeaders.push('Zdjęcie')
    }
    if (type === 4 && (finalize || (edit && formik.values.status_id != 1))) {
      aHeaders.push('Zdjęcie')
    }
    // if (!finalize) {
    //   dHeaders.push('')
    // }
    if (type === 1) {
      setHeaders(aHeaders)
    } else if (type === 2) {
      setHeaders(dHeaders)
    } else if (type === 3) {
      setHeaders(dHeaders)
    } else if (type === 4) {
      setHeaders(aHeaders)
    }
  }

  // const loadFields = () => {
  //   axios.post('/lookups/fields').then((res) => {
  //     if (res.status == 200) {
  //       setFields(res.data)
  //     }
  //   })
  // }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {headers &&
            headers.map((header, index) => (
              <TableCell
                key={index}
                style={
                  {
                    // width: `${100 / headers.length}%`,
                    // whiteSpace: 'nowrap',
                  }
                }
              >
                {header}
              </TableCell>
            ))}
          {!(finalize || edit) && <TableCell>Akcja</TableCell>}
        </TableRow>
      </TableHead>
      <TableBody>
        {examinations &&
          type === 1 &&
          formik.values.examinations['1'] &&
          Object.keys(formik.values.examinations['1']).length &&
          Object.keys(formik.values.examinations['1']).map((key) => (
            <ExaminationRowT1
              formik={formik}
              examinations={examinations['1']}
              patient={patient}
              keyString={key}
              key={key}
              handleChange={handleChange}
              assignFile={(variable, value) => {
                assignFileToComponent(type, key, value)
              }}
              deleteRow={deleteRow}
              finalize={finalize}
              edit={edit}
              internal={internal}
            />
          ))}
        {examinations &&
          type === 2 &&
          formik.values.examinations['2'] &&
          Object.keys(formik.values.examinations['2']).length &&
          Object.keys(formik.values.examinations['2']).map((key) => (
            <ExaminationRowT2
              formik={formik}
              examinations={examinations['2']}
              patient={patient}
              keyString={key}
              key={key}
              files={getFiles(2, key)}
              // currentFile={usedFiles[2] ? usedFiles[2][key] : null}
              handleChange={handleChange}
              assignFile={(variable, value) => {
                assignFileToComponent(type, key, value)
              }}
              deleteRow={deleteRow}
              editFile={editFile}
              finalize={finalize}
              edit={edit}
              internal={internal}
            />
          ))}
        {examinations &&
          type === 3 &&
          formik.values.examinations['3'] &&
          Object.keys(formik.values.examinations['3']).length &&
          Object.keys(formik.values.examinations['3']).map((key) => (
            <ExaminationRowT3
              formik={formik}
              examinations={examinations['3']}
              patient={patient}
              keyString={key}
              key={key}
              files={getFiles(3, key)}
              handleChange={handleChange}
              assignFile={(variable, value) => {
                assignFileToComponent(type, key, value)
              }}
              deleteRow={deleteRow}
              editFile={editFile}
              finalize={finalize}
              edit={edit}
              internal={internal}
            />
          ))}
        {examinations &&
          type === 4 &&
          formik.values.examinations['4'] &&
          Object.keys(formik.values.examinations['4']).length &&
          Object.keys(formik.values.examinations['4']).map((key) => (
            <ExaminationRowT4
              formik={formik}
              examinations={examinations['4']}
              patient={patient}
              keyString={key}
              key={key}
              files={getFiles(4, key)}
              handleChange={handleChange}
              assignFile={(variable, value) => {
                assignFileToComponent(type, key, value)
              }}
              deleteRow={deleteRow}
              finalize={finalize}
              edit={edit}
              internal={internal}
            />
          ))}
        <SummaryRow
          skip={summarySkip}
          examinations={formik.values.examinations[type]}
        />
      </TableBody>
    </Table>
  )
}

ExaminationsTable.propTypes = {
  type: PropTypes.number,
  formik: PropTypes.object,
  patient: PropTypes.number,
  summarySkip: PropTypes.number,
  handleChange: PropTypes.func,
  assignFileToComponent: PropTypes.func,
  deleteRow: PropTypes.func,
  editFile: PropTypes.func,
  examinations: PropTypes.object,
  finalize: PropTypes.bool,
  internal: PropTypes.bool,
  edit: PropTypes.bool,
  getFiles: PropTypes.func,
}

export default ExaminationsTable
